import React from 'react';

const ago = (ts) => {
  const d = (Date.now() - new Date(ts).getTime()) / 86400000;
  if (d < 1) return 'today';
  if (d < 2) return 'yesterday';
  return `${Math.floor(d)} days ago`;
};

export const PrideList = ({ name, pride = [] }) => {
  if (!pride.length) return null;
  return (
    <div className="home-card" data-testid="pride-list">
      <p className="text-xs uppercase tracking-[0.25em] text-bx-pink font-bold">Things {name} is proud of</p>
      <ul className="mt-3 space-y-3">
        {pride.map((p, i) => (
          <li key={i} className="flex items-start gap-3" data-testid={`pride-item-${i}`}>
            <span className="mt-2 h-1.5 w-1.5 rounded-full bg-bx-pink shrink-0" />
            <div>
              <p className="text-white/90">{p.text}</p>
              <p className="text-xs text-white/55">{ago(p.ts)}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PrideList;
